
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="5">
                <label for="select-empresa">Empresa</label>  
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

            <b-col cols=1 class="mt-4">
                    
          <b-button size="sm" id="btn-pesquisar" variant="success" block class="mr-2 mt-1 "  @click="loadKpiDia(), loadKpiFilial(),loadSacSinistros(), loadKpiFuncionario(),loadKpiSolicitacapLinha()">
              <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Filtrar gráfico
          </b-button>
              </b-col>

          </b-row>
    </b-form>   

    <div>
      <b-row>

            <b-col cols=3 class="mt-3">

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="SINISTRO PENDENTES"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ sinistros.filter( s => s.status === 'PENDENTE').length }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols=3 class="mt-3">
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="SINISTRO EM ATENDIMENTO"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ sinistros.filter( s => s.status === 'EM ATENDIMENTO').length }}
                </h2>
                
                
              </b-card-text>
            </b-card>
            </b-col>

          <b-col cols=3 class="mt-3">
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="SINISTRO FINALIZADAS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ sinistros.filter( s => s.status === 'FINALIZADO').length }}
                </h2>
                
              </b-card-text>
      </b-card>        
      </b-col>
      
      <b-col cols=3 class="mt-3">
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="TOTAL DE SINISTRO "
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{sinistros.length}} 
              </h2>
              
            </b-card-text>
          </b-card>
        </b-col>

      </b-row>
      
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="12" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>

          <!-- acumulado  FILIAL -->
          <b-col cols="4">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

          <!-- acumulado  Linha -->
          <b-col cols="4">
            <apexcharts 
            ref="chartlinha"
            height="400" :options="graficoLinha" 
            :series="serieslinha"></apexcharts>
          </b-col>

          <!-- acumulado  FUNCIONARIO -->
          <b-col cols="4">
            <apexcharts
            ref="chartfuncionario" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesfuncionario"
            ></apexcharts>
          </b-col>
        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Sinistros diários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },
  

  /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350,                                      
            foreColor:"black",                         
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
          title: {
            text: 'Sinistros por filial',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },

  /* Linha */
  graficoLinha: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {
        horizontal: true,
        //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Sinistros por linha',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


   


/* funcionario    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 10 por funcionários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


/* dados diario  */
series: [{
        name: 'RA',
        data: [144, 155, 141, 137, 135]
      }, {
        name: 'S.O.S',
        data: [153, 132, 133, 152, 145  ]
      }, {
        name: 'REC NORMAL',
        data: [112, 117, 111, 119, 118 ]
      }, {
      name: 'REC ANORMAL',
      data: [119, 117, 115, 118, 116 ]
    },],

    

/* objetos */

  kpifiliais:[],  
  kpidias:[],  
  kpifuncionario:[] ,
  kpilinha:[],
  dt_inicial: '',
  dt_final: '',  
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesdia:[],
  seriesfilial:[],  
  seriesfuncionario:[],
  serieslinha:[],
  empresa:{}, 
  empresas:[],   // [] lista       
  filial:{}, 
  filiais: [],   // [] lista   
  sinistros:[],
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {      

      /// filtros por filial
      async loadKpiFilial() {
          let params = {    
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
        "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string                                                                         
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,     
                                "psg":  `${this.user.psg}`,                                          
          };
          const url = `${baseApiUrl}/indicadores/sinistro_filial`
          axios.get(url,{params})
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();              
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                                                      
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd_sinistro));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },

      /// filtros por dia 
async loadKpiDia() {
    // Montando o objeto params de forma mais clara e sem redundâncias
    let params = {    
        "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
        "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string
        "dt_inicial": this.dt_inicial,  // Não precisa do template literal se já for uma variável
        "dt_final": this.dt_final,      // Não precisa do template literal se já for uma variável
        "psg": this.user.psg           // Adiciona o 'psg' nos parâmetros
    };

    const url = `${baseApiUrl}/indicadores/sinistro_dia`;  // Não é necessário o 'await' aqui, apenas uma string

    // Fazendo a requisição GET usando axios
    axios.get(url, { params })
        .then(res => {
            this.kpidias = res.data;  // Atualiza o estado com os dados da resposta
            this.updateChartDataDia(); // Atualiza o gráfico com os novos dados
        })
        .catch(showError);  // Caso haja erro, exibe-o
},
    
    async updateChartDataDia() {
      this.seriesdia = [{
        name: 'Qtd sinistros',
        data: this.kpidias.map(item => parseInt(item.qtd_sinistro)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        categories: this.kpidias.map(d => d.dia)
      }  });       
    },

    /// filtros por funcionario  21/08/2023
      async loadKpiFuncionario() {
            let params = {    
               "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
        "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string                                    
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,        
                                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                       
            };
          const url = await `${baseApiUrl}/indicadores/sinistro_funcionario`
          axios.get(url,{params})
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd sinistros',
        data: this.kpifuncionario.map(item => parseInt(item.qtd_registro)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.registro)
      }  });       
    },

/// filtros por linha tipo solicitação  21/08/2023
      async loadKpiSolicitacapLinha() {
            let params = {    
              "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
        "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,  
                                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                             
            };
          const url = await `${baseApiUrl}/indicadores/sinistro_linha`
          axios.get(url,{params})
            .then(res => {              
            this.kpilinha = res.data 
            this.updateKpiSolicitacaoLinha();               
            })
            .catch(showError)
    },
    
    async updateKpiSolicitacaoLinha() {
      this.serieslinha = [{
        name: 'Qtd sinistros',
        data: this.kpilinha.map(item => parseInt(item.qtd_linha)),
        }];
      this.$refs.chartlinha.updateOptions({ xaxis:{
        categories: this.kpilinha.map(d => d.linha)
      }  });       
    },

    loadEmpresas() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params}).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
    },  
      
    loadFiliais() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                                              "id_empresa": `${this.user.id_empresa}`,
                                "psg":  `${this.user.psg}`,                                              
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params}).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
    },
        
       
    loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,  
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                             
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.get(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
            //this.loadSacSinistros()
            
          })
    },

    loadSacSinistros() {
            let params = {                    
               "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
               "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string                        
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,    
                   "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                                           
            }; 
            const url = `${baseApiUrl}/indicadores/sinistro`            
            axios.get(url,{params})
                  .then(res => {              
                  this.sinistros = res.data                      
                  })
                  .catch(showError)
                            
    },



    },

    created(){
      this.loadPermissao()           
    },



    mounted(){
        this.loadEmpresas()   
        this.loadKpiDia()   
        this.loadKpiFuncionario()  
        this.loadKpiSolicitacapLinha()   
        this.loadKpiFilial()                             
        this.loadSacSinistros()
    },
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>